import fetch from '@/utils/fetch'
import {
    shop_url
  } from '@/global'
const MANAGE_USER = `${shop_url}/shop/mp/admin/user`

 /*
    获取员工列表
 */
export const getMems = (page, pageSize, mchId, searchStr) => {
  return fetch({
    url: MANAGE_USER + `/${mchId}/${page}/${pageSize}?keyWord=${searchStr}`,
    method: 'get'
  })
}

/*
 */
export const addMem = (data) => {
  return fetch({
      url: MANAGE_USER,
      method: 'post',
      data: data
    })
}
/*
 */
export const editMem = (data) => {
  return fetch({
      url: MANAGE_USER,
      method: 'put',
      data: data
    })
}

export const deleteMem = (userId) => {
  return fetch({
      url: MANAGE_USER + '/' + userId,
      method: 'delete'
    })
}

export const getDecoration = (mchId) => {
  return fetch({
      url: `${shop_url}/shop/shop/page/${mchId}`,
      method: 'get'
    })
}

export const setDecoration = (data) => {
  return fetch({
      url: `${shop_url}/shop/shop/page`,
      method: 'post',
      data,
    })
}



// WEBPACK FOOTER //
// ./src/api/manageMems/index.js